import _ from 'lodash';

import {
  primaryColor,
  successColor,
  errorColor,
  warnColor,
  infoColor,
} from '../common/theme';

export function mapStatus(status) {
  switch (status) {
    case 'ORDERED':
    case 'ACKNOWLEDGED':
    case 'APPROVED':
      return 'APPROVED';
    case 'ASSIGNED':
      return 'ASSIGNED';
    case 'IN_PROGRESS':
      return 'IN_PROGRESS';
    case 'DELEGATED':
      return 'DELEGATED';
    case 'DELIVERED':
      return 'DELIVERED';
    case 'COMPLETED':
      return 'COMPLETED';
    case 'FAILED':
      return 'FAILED';
    case 'CANCELED':
      return 'CANCELED';
    default:
      console.debug(`Unknown status in mapStatus: ${status}`);
      return 'FAILED';
  }
}

export function getTransportStatusLabel(status) {
  switch (mapStatus(status)) {
    case 'APPROVED':
      return 'Kuljetus odottaa käsittelyä';
    case 'ASSIGNED':
      return 'Kuljetus varattu';
    case 'IN_PROGRESS':
      return 'Kuljetus käynnissä';
    case 'DELIVERED':
      return 'Kuljetettu';
    case 'COMPLETED':
      return 'Kuljetus valmis';
    default: {
      console.debug(`Unknown status in getTransportStatusLabel: ${status}`);
      return 'Tuntematon status';
    }
  }
}

export function getStatusLabel(status) {
  switch (mapStatus(status)) {
    case 'APPROVED':
      return 'Tilaus odottaa käsittelyä';
    case 'IN_PROGRESS':
      return 'Tilaus käynnissä';
    case 'DELEGATED':
      return 'Tilaus välitetty palveluntuottajalle';
    case 'FAILED':
      return 'Tilaus epäonnistunut';
    case 'CANCELED':
      return 'Tilaus peruttu';
    case 'COMPLETED':
      return 'Tilaus valmis';
    default: {
      console.debug(`Unknown status in getStatusLabel: ${status}`);
      return 'Tuntematon status';
    }
  }
}

export function progressToBeadStates(progress) {
  const orderStates = progress.map(({ orderStatus }) => orderStatus);
  const active = _.findLast(progress, ({ time }) => time !== null);

  return progress.map(({ time, orderStatus }) => {
    // Assume upcoming if time is null
    if (!time) {
      if (orderStates.includes('CANCELED')) {
        return 'CANCELED_UPCOMING';
      }
      return 'UPCOMING';
    }

    if (orderStatus === active.orderStatus) {
      if (orderStatus === 'DELIVERED') {
        return 'PENDING';
      }
      return 'ACTIVE';
    }

    switch (orderStatus) {
      case 'CANCELED':
        return 'CANCELED';
      case 'DELIVERED':
      case 'DELEGATED':
        return 'PENDING';
      default:
        return 'DONE';
    }
  });
}

/**
 * @deprecated
 */
export function oldGetStatusLabel(status) {
  switch (status) {
    case 'ORDERED':
      return 'Tilattu';
    case 'APPROVED':
      return 'Hyväksytty';
    case 'ACKNOWLEDGED':
      return 'Kuitattu';
    case 'DELIVERED':
      return 'Kuljetettu';
    case 'IN_PROGRESS':
      return 'Käynnissä';
    case 'COMPLETED':
      return 'Valmis';
    case 'CANCELED':
      return 'Peruttu';
    case 'DELEGATED':
      return 'Välitetty';
    case 'ASSIGNED':
      return 'Varattu';
    case 'FAILED':
      return 'Epäonnistunut';
    default: {
      console.debug(`Unknown status in getStatusLabel: ${status}`);
      return 'Tuntematon status';
    }
  }
}

// TODO use colors from GlobalStyles here

/**
 * @deprecated
 */
export function getStatusColor(status) {
  switch (status) {
    case 'ORDERED':
      return '#888';
    case 'APPROVED':
      return '#ccc';
    case 'ACKNOWLEDGED':
      return primaryColor;
    case 'ASSIGNED':
      return '#ccc';
    case 'DELIVERED':
      return warnColor;
    case 'IN_PROGRESS':
      return infoColor;
    case 'COMPLETED':
      return successColor;
    case 'CANCELED':
      return errorColor;
    case 'FAILED':
      return errorColor;
    default: {
      console.debug(`Unknown status in getStatusColor: ${status}`);
      return '#888';
    }
  }
}

/**
 * @deprecated
 */
export function getStatusTextColor(status) {
  switch (status) {
    case 'ORDERED':
      return 'white';
    case 'APPROVED':
      return 'black';
    case 'ACKNOWLEDGED':
      return 'white';
    case 'ASSIGNED':
      return 'black';
    case 'DELIVERED':
      return 'black';
    case 'IN_PROGRESS':
      return 'black';
    case 'COMPLETED':
      return 'white';
    case 'CANCELED':
      return 'black';
    case 'FAILED':
      return 'black';
    default: {
      console.debug(`Unknown status in getStatusTextColor: ${status}`);
      return 'white';
    }
  }
}
